export const EMPLOYEE_PAGES = {
  employee: 'employee',
  employeeInterview: 'employeeInterview',
  employeeProfile: 'employeeProfile',
  employeeDetails: 'employeeDetails',
  appraisalInterviewDetails: 'appraisalInterviewDetails',
  createEmployee: 'createEmployee',
  employeeLimitedView: 'employeeLimitedView',
  createEmployeeByQuestionnaire: 'createEmployeeByQuestionnaire',
  openQuestionnaires: 'openQuestionnaires',
  openQuestionnairesDetails: 'openQuestionnairesDetails',
  acceptQuestionnaire: 'acceptQuestionnaire',
};
